export default {
    mapper: {
        relations: {
            belongsTo: {
                address: {
                    foreignKey: 'address_id',
                    localField: 'address',
                },
                vendor: {
                    foreignKey: 'vendor_id',
                    localField: 'vendor',
                },
            },
        },
    },
};
